/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * What kind of number companyRegNumber holds, so it can be validated and read correctly.
 */
export type RegistrationNumberType = typeof RegistrationNumberType[keyof typeof RegistrationNumberType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegistrationNumberType = {
  CIPC: 'CIPC',
  PRACTICE_NUMBER: 'PRACTICE_NUMBER',
  TRUST_NUMBER: 'TRUST_NUMBER',
  ID_NUMBER: 'ID_NUMBER',
  OTHER: 'OTHER',
  CUSTOMER_REFERENCE: 'CUSTOMER_REFERENCE',
} as const;
